import { allTokenInfosAtom } from "@/atoms/tokenInfos"
import { Seo } from "@/components/base"
import Layout from "@/components/layout"
import { Staking } from "@/components/staking"
import useMarketSelection from "@/hooks/useMarketSelection"
import useTrans from "@/hooks/useTrans"
import { IS_MAINNET } from "@/utils/constants"
import { errorWrapper } from "@/utils/helpers"
import fetchNecessaryTokenInfos from "@/utils/restaking/fetchNecessaryTokenInfos"
import { sendEventLog } from "@/utils/tracking-events"
import { useSetAtom } from "jotai"
import { GetStaticProps } from "next"
import { useEffect } from "react"
import { QueryClient, dehydrate, useQuery } from "react-query"

export default function StakingPage() {
  const trans = useTrans()
  const { data: allTokenInfos } = useQuery(["fetchNecessaryTokenInfos"], () => fetchNecessaryTokenInfos(), {
    refetchOnWindowFocus: false,
  })

  const setAllTokenInfos = useSetAtom(allTokenInfosAtom)

  useEffect(() => {
    sendEventLog("view_relend_staking_page", {
      isMainnet: IS_MAINNET,
    })
  }, [])

  useEffect(() => {
    if (allTokenInfos && allTokenInfos.length > 0) {
      setAllTokenInfos(allTokenInfos)
    }
  }, [allTokenInfos, setAllTokenInfos])

  useMarketSelection()

  return (
    <>
      <Seo
        data={{
          title: `${trans.seo.seo_title_staking}`,
          description: trans.seo.seo_description_staking,
        }}
      />
      <Layout>
        <Staking />
      </Layout>
    </>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const queryClient = new QueryClient()
  await errorWrapper(() => queryClient.prefetchQuery(["fetchNecessaryTokenInfos"], () => fetchNecessaryTokenInfos()))

  return {
    props: {
      locale,
      dehydratedState: dehydrate(queryClient),
    },
    revalidate: 30,
  }
}
